import * as React from 'react'

import Grid from '@mui/material/Unstable_Grid2'
import Stack, { StackProps } from '@mui/material/Stack'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'

import Text from 'components/atomic/atoms/text'
import { GridSize } from '@mui/material'

interface ListItem {
    slug: string
}

interface ItemListProps<T extends ListItem> extends StackProps {
    title: string
    items: T[]
    renderItem: (item: T) => JSX.Element
    itemColumns?: {
        xs?: boolean | GridSize | undefined
        sm?: boolean | GridSize | undefined
        md?: boolean | GridSize | undefined
        lg?: boolean | GridSize | undefined
        xl?: boolean | GridSize | undefined
    }
}

export default function ItemList<T extends ListItem>({
    title,
    items,
    renderItem,
    itemColumns,
    ...props
}: ItemListProps<T>) {
    return (
        <Stack {...props}>
            <Text variant="h6" marginRight={1}>
                {title}
            </Text>

            {/* Items */}
            <Box pt={1}>
                <Grid container spacing={{ xs: 2, md: 1 }}>
                    {items.map((item) => (
                        <Grid {...itemColumns} key={item.slug}>
                            {renderItem(item)}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Stack>
    )
}
